import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../../../node_modules/@flixbus/honeycomb/dist/scss/components/calendar.scss.js';
import HoneyBem from '../../../../packages/honey-bem/honey-bem.js';
import Select from '../../../select/select.js';
import SelectOption from '../../../select/select-option/select-option.js';

const bem = new HoneyBem('calendar-header', styles);
function HeaderBirthday(_ref) {
  let {
    calendar,
    months,
    selected,
    onChangeDate,
    birthdaySelectMonth,
    birthdaySelectYear,
    id
  } = _ref;
  const onMonthChange = e => {
    onChangeDate(new Date(selected.getFullYear(), months.findIndex(month => month === e.target.value), 1));
  };
  const onYearChange = e => {
    onChangeDate(new Date(parseInt(e.target.value, 10), selected.getMonth(), 1));
  };
  const yearsArray = calendar && Array.from(calendar.years);
  return /*#__PURE__*/React.createElement("div", {
    className: bem.b('birthday')
  }, /*#__PURE__*/React.createElement(Select, Object.assign({
    extraClasses: bem.e('select'),
    id: "".concat(id, "-month-select"),
    onChange: onMonthChange,
    value: months[selected.getMonth()],
    "aria-controls": "".concat(id, "-grid")
  }, birthdaySelectMonth), months.map(month => /*#__PURE__*/React.createElement(SelectOption, {
    key: month,
    value: month
  }))), /*#__PURE__*/React.createElement(Select, Object.assign({
    extraClasses: bem.e('select'),
    id: "".concat(id, "-year-select"),
    onChange: onYearChange,
    value: selected.getFullYear(),
    "aria-controls": "".concat(id, "-grid")
  }, birthdaySelectYear), yearsArray === null || yearsArray === void 0 ? void 0 : yearsArray.map(year => /*#__PURE__*/React.createElement(SelectOption, {
    key: year,
    value: year
  }))));
}
HeaderBirthday.propTypes = {
  id: PropTypes.string.isRequired,
  calendar: PropTypes.shape({}).isRequired,
  months: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.instanceOf(Date).isRequired,
  onChangeDate: PropTypes.func.isRequired,
  birthdaySelectMonth: PropTypes.shape({}).isRequired,
  birthdaySelectYear: PropTypes.shape({}).isRequired
};

export { HeaderBirthday };
